// extracted by mini-css-extract-plugin
module.exports = {"container":"FlexColumn_container__K0pdH","reversed":"FlexColumn_reversed__NZQ01","alignCenter":"FlexColumn_alignCenter__9Wu_k"};